import i18n, { InitOptions } from 'i18next';
import Cookies from 'js-cookie';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
	en: require('./en.json'),
	de: require('./de.json'),
};

export function getFallbackLanguage(code: string): string {
	if (code.startsWith('de')) {
		return 'de';
	}
	return 'en';
}

i18n
	.use(LanguageDetector) // detect user language
	.use(initReactI18next) // passes i18n down to react-i18next
	.init({
		detection: { checkWhitelist: true },
		fallbackLng: getFallbackLanguage,
		resources,
		keySeparator: '.',
		interpolation: {
			escapeValue: false, // react already safes from xss
		},
		debug: true,
	} as InitOptions);

const setLanguageCookie = function (language: string) {
	Cookies.set('.AspNetCore.Culture', `c=${language}|uic=${language}`, {
		expires: new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 365),
	});
};

setLanguageCookie(i18n.language ?? 'en');
i18n.on('languageChanged', (lng) => {
	setLanguageCookie(lng);
});

export default i18n;
